/* eslint-disable promise/catch-or-return */
import context from '@/context'
import { processUserReport, getCellMetadataFromReportSubmissionData } from '@/store/utils/reportUtils'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  fetching: false,
  fetchingId: null,
  adding: false,
  removing: false,
  attachmentsKey: getComponentKey(),
  institutionReport: null,
  sourceHeaders: null,
  sourceRowHeaders: null,
  sourceDataUpdating: false,
  sourceDataRecalculating: false,
  sourceData: [],
  cellMetadata: []
}

export const actionTypes = {
  InstitutionReportFetching: 'institutionReport/fetching',
  InstitutionReportFetched: 'institutionReport/fetched',
  InstitutionReportAttachmentAdding: 'institutionReport/attachment/adding',
  InstitutionReportAttachmentAdded: 'institutionReport/attachment/added',
  InstitutionReportAttachmentRemoving: 'institutionReport/attachment/removing',
  InstitutionReportAttachmentRemoved: 'institutionReport/attachment/removed',
  InstitutionReportError: 'institutionReport/error'
}

const getInternal = (dispatch, getState, reportId, groupId) => {
  dispatch({ type: actionTypes.InstitutionReportFetching, data: reportId })

  const resp = response => {
    try {
      const grid = processUserReport(response)
      const sourceData = response.reportSubmissionCells

      const cellMetadata = getCellMetadataFromReportSubmissionData(response.reportSubmissionCells)

      dispatch({ type: actionTypes.InstitutionReportFetched, data: { grid, sourceData, cellMetadata } })
    } catch (err) {
      dispatch({ type: actionTypes.InstitutionReportError, update: { fetching: false, fetchingId: null } })
    }
  }

  const err = () => dispatch({ type: actionTypes.InstitutionReportError, update: { fetching: false, fetchingId: null } })

  if (!groupId) context.api.institutionReportService.get(reportId, allowErrorDialog).then(resp).catch(err)
  else context.api.institutionReportService.getByGroup(groupId, reportId).then(resp).catch(err)
}

export const actionCreators = {
  get: (id, groupId) => (dispatch, getState) => {
    const state = getState()

    // Report loading is an expensive operation,
    // so we should prevent this from happening when report with the same id is being loaded
    if (state.institutionReports.fetchingId === id ||
            (state.institutionReports.institutionReport !== null &&
                state.institutionReports.institutionReport.id === id)) return

    getInternal(dispatch, getState, id, groupId)
  },
  addAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.InstitutionReportAttachmentAdding })
    context.api.institutionReportService.addAttachments(input)
      .then(response => {
        dispatch({ type: actionTypes.InstitutionReportAttachmentAdded })
      })
      .catch(() => dispatch({ type: actionTypes.InstitutionReportError, update: { adding: false } }))
  },
  removeAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.InstitutionReportAttachmentRemoving })
    context.api.institutionReportService.removeAttachments(input)
      .then(response => {
        dispatch({ type: actionTypes.InstitutionReportAttachmentRemoved })
      })
      .catch(() => dispatch({ type: actionTypes.InstitutionReportError, update: { removing: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.InstitutionReportFetching: return { ...state, fetching: true, fetchingId: action.data }
    case actionTypes.InstitutionReportFetched: return {
      ...state,
      fetching: false,
      fetchingId: null,
      sourceDataSaving: false,
      sourceDataSavingError: false,
      institutionReport: action.data.grid,
      sourceRowHeaders: action.data.grid.allRows,
      sourceHeaders: action.data.grid.allCols,
      sourceData: action.data.sourceData,
      cellMetadata: action.data.cellMetadata,
      key: state.key + 1
    }
    case actionTypes.InstitutionReportAttachmentAdding: return { ...state, adding: true }
    case actionTypes.InstitutionReportAttachmentAdded: return { ...state, adding: false, attachmentsKey: getComponentKey() }
    case actionTypes.InstitutionReportAttachmentRemoving: return { ...state, removing: true }
    case actionTypes.InstitutionReportAttachmentRemoved: return { ...state, removing: false, attachmentsKey: getComponentKey() }
    case actionTypes.InstitutionReportError: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/InstitutionReports.js